import React from 'react';
import { cn } from '../../lib/utils';
import { Button } from '../ui/button';
import { Save, X, Trash2, Edit } from 'lucide-react';

export function EntryBar({ 
  onSave, 
  onCancel, 
  onDelete, 
  onEdit,
  saveLabel = "Save",
  saveShortcut = "Ctrl+S",
  isEditing = false,
  isLoading = false,
  className,
  children 
}) {
  // Handle keyboard shortcuts
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        onSave?.();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        onCancel?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onSave, onCancel]);

  return (
    <div className={cn("entry-bar", className)} data-testid="entry-bar">
      <div className="flex-1 flex items-center gap-2">
        {children}
      </div>
      <div className="flex items-center gap-2">
        {onEdit && !isEditing && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onEdit}
            data-testid="entry-edit-btn"
          >
            <Edit className="h-3.5 w-3.5 mr-1" />
            Edit
          </Button>
        )}
        {onDelete && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onDelete}
            className="text-destructive hover:text-destructive"
            data-testid="entry-delete-btn"
          >
            <Trash2 className="h-3.5 w-3.5 mr-1" />
            Delete
          </Button>
        )}
        {onCancel && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onCancel}
            data-testid="entry-cancel-btn"
          >
            <X className="h-3.5 w-3.5 mr-1" />
            Cancel <span className="kbd ml-1">Esc</span>
          </Button>
        )}
        {onSave && (
          <Button 
            size="sm" 
            onClick={onSave}
            disabled={isLoading}
            data-testid="entry-save-btn"
          >
            <Save className="h-3.5 w-3.5 mr-1" />
            {saveLabel} <span className="kbd ml-1">{saveShortcut}</span>
          </Button>
        )}
      </div>
    </div>
  );
}
